import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../hooks/useLanguage';

const copy = {
  RU: {
    title: 'Основные модификации',
    intro: 'Основные варианты пулемётов и станков, представленные в архиве.',
    count: 'позиций',
    guns: 'Пулемёты',
    mounts: 'Станки',
    open: 'Открыть в каталоге',
    groups: [
      [
        ['Пулемёт Максима обр. 1895 г. (DWM, VSM)', 'До начала производства на Тульском оружейном заводе', { q: '1895' }],
        ['Пулемёт Максима обр. 1905 г.', 'Конусный бронзовый кожух', { q: 'Максим образца 1905г' }],
        ['Пулемёт Максима обр. 1910 г.', 'Стальной гофрированный кожух, до Первой мировой войны', { q: 'Максим образца 1910г с гофрированным кожухом' }],
        ['Лёгкий пулемёт Максима', 'Особые прицел и надульник', { q: 'Легкий', belongsTo: 'максим' }],
        ['Пулемёт Максима обр. 1910 г.', 'Бронзовый гладкий кожух', { q: 'Пулемет максим образца 1910г с бронзовым' }],
      ],
      [
        ['Ранний станок Соколова', 'С ограничителями', { q: 'с ограничителями' }],
        ['Станок Соколова ОРЗ', 'Производство ОРЗ, до 1917 года', { manufacturer: 'ОР.З.' }],
        ['Тульский станок Соколова', 'Производство ТОЗ', { manufacturer: 'ТОЗ', belongsTo: 'станок' }],
        ['Станок Колесникова', 'Две известные разновидности', { q: 'колесников' }],
      ],
    ],
  },
  EN: {
    title: 'Main variants',
    intro: 'Principal Maxim gun and mount variants represented in the archive.',
    count: 'entries',
    guns: 'Guns',
    mounts: 'Mounts',
    open: 'Open in catalogue',
    groups: [
      [
        ['Maxim gun Model 1895 (DWM, VSM)', 'Before production began at the Tula Arms Plant', { q: '1895' }],
        ['Maxim gun Model 1905', 'Conical bronze water jacket', { q: 'Максим образца 1905г' }],
        ['Maxim gun Model 1910', 'Corrugated steel water jacket, pre-war production', { q: 'Максим образца 1910г с гофрированным кожухом' }],
        ['Light Maxim gun', 'Distinctive sight and muzzle attachment', { q: 'Легкий', belongsTo: 'максим' }],
        ['Maxim gun Model 1910', 'Smooth bronze water jacket', { q: 'Пулемет максим образца 1910г с бронзовым' }],
      ],
      [
        ['Early Sokolov mount', 'With travel stops', { q: 'с ограничителями' }],
        ['Sokolov mount, ORZ', 'Made by ORZ before 1917', { manufacturer: 'ОР.З.' }],
        ['Tula Sokolov mount', 'Made by TOZ', { manufacturer: 'ТОЗ', belongsTo: 'станок' }],
        ['Kolesnikov mount', 'Two known variants', { q: 'колесников' }],
      ],
    ],
  },
};

function catalogueUrl(filters) {
  const params = new URLSearchParams({
    q: filters.q || '',
    searchType: 'all',
    page: '0',
    sortField: 'relevance',
    sortOrder: 'desc',
    size: '20',
  });

  if (filters.manufacturer) params.set('manufacturer', filters.manufacturer);
  if (filters.belongsTo) params.set('belongsTo', filters.belongsTo);
  return `/search?${params.toString()}`;
}

export default function ModificationsPage() {
  const { lang } = useLanguage();
  const labels = copy[lang] || copy.RU;
  const total = labels.groups.reduce((sum, group) => sum + group.length, 0);

  return (
    <main className="directory-page modifications-page page-width">
      <header className="directory-header modifications-header">
        <div>
          <h1>{labels.title}</h1>
          <p>{labels.intro}</p>
        </div>
        <span>{String(total).padStart(2, '0')} {labels.count}</span>
      </header>

      <div className="modifications-groups">
        {labels.groups.map((items, groupIndex) => (
          <section className="modifications-group" key={groupIndex}>
            <h2>{groupIndex === 0 ? labels.guns : labels.mounts}</h2>
            <div className="modifications-list">
              {items.map(([title, subtitle, filters], itemIndex) => (
                <Link className="modification-row" to={catalogueUrl(filters)} key={`${groupIndex}-${itemIndex}`}>
                  <span>{String(itemIndex + 1).padStart(2, '0')}</span>
                  <span className="modification-row__copy">
                    <strong>{title}</strong>
                    <small>{subtitle}</small>
                    <em>{labels.open}</em>
                  </span>
                  <ArrowRight size={18} />
                </Link>
              ))}
            </div>
          </section>
        ))}
      </div>
    </main>
  );
}
